import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogTundishReducer } from "./CatalogTundishReducer";

const CatalogTundishContext = createContext({
  state: CatalogTundishReducer.getInitialState(),
  actions: CatalogTundishReducer.actions,
});

export const useCatalogTundishContext = () => useContext(CatalogTundishContext);

export const CatalogTundishProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, actions] = useComplexState({
    initialState: CatalogTundishReducer.getInitialState(),
    reducers: CatalogTundishReducer.caseReducers,
  });
  return (
    <CatalogTundishContext.Provider value={{ state, actions }}>
      {children}
    </CatalogTundishContext.Provider>
  );
};
